<template>
	<div class="full-width column centering flexible article">
        <div v-if="promoDetails" class="panel">
            <header class="column centering separated">
                <i class="fas fa-check-circle success"></i>
                <h1 class="rigid capitalize">Promotion Redeemed</h1>
            </header>
            <section class="column centering">
                <p class="rigid centered">
                    Start using your new TekCloud subscription<span v-if="promoDetails.items[1]">s</span> now.
                </p>
                <footer class="column flexible separated">
                    <a v-if="promoDetails.items[0]" class="button flexible" target="_blank" :href="driveUrl + '&r=newuser'">Open TekDrive</a>
                    <a v-if="promoDetails.items[1]" class="button flexible" target="_blank" :href="installTekScopeUrl">Install TekScope</a>
                    <router-link to="/">Account Home</router-link>
                </footer>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SubmitButton from '@/components/SubmitButton';
import PaymentNotice from '@/components/PaymentNotice';
import Spinner from '@/components/Spinner';

export default {
	name: 'Confirmation',
	data(){
		return {
			submitting: false,
			addSubscriptionError: null
		};
	},
	props: {
		promoDetails: Object
	},
	components:{
		SubmitButton,
		Spinner,
		PaymentNotice
	},
	computed:{
		...mapGetters([
			'address',
			'userStatus',
			'account'
		]),
		...mapGetters('auth', {
			driveUrl: 'driveAppUrl',
			installTekScopeUrl : 'installTekScopeUrl',
		}),
	},
	methods:{
		back() {
			const navigationStep = {
				current: this.navigation.next,
				next: 'Review',
				previous: 'PaymentMethod',
				previousLabel: 'Payment Method',
				isLink: false
			};
			this.$emit('navigation', navigationStep);
		}
	}
};
</script>

<style scoped>
.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: 25.6px auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.content {
    padding: 0;
}

section {
    width: 300px;
    margin: auto;
}

section > p {
    margin-bottom: 1em;
}

i.fas {
    font-size: 4rem;
}

p.centered {
    text-align: center;
}

footer {
	margin: 1em auto 0;
    width: 300px;
}

footer > a {
    width: 100%;
    text-align: center;
}

footer > a:last-child {
    margin-top: 1em;
}

</style>



// WEBPACK FOOTER //
// ./src/views/promotions/Confirmation.vue